import { PreOrderInformationMessage } from '@/messages/common';

import * as S from './PreOrderInformation.styles';

export const PreOrderInformation = () => {
  return (
    <S.Text data-testid='PreOrderInformation-pdp'>
      {PreOrderInformationMessage}
    </S.Text>
  );
};
